import styled from 'styled-components';

const InputSpan = styled.span`
  height: 4rem;
  width: 4rem;
  display: inline-flex;
  justify-content: center;
  align-items: center;
  font-size: 2rem;
`;

const Img = styled.img`
  width: 100%;
`;

export { InputSpan, Img };
